module.exports = __webpack_public_path__ + "static/media/failed-01.4e62cfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/failed-01.png
// module id = 520
// module chunks = 0